'use client';

import React from 'react';
import { useWidgetConfig } from 'src/context/providers/WidgetConfigProvider';
import { EvidenceInfoIcon } from '../PlaysSection/components';

interface WidgetHeaderProps {
  fallbackTitle: string;
  trailing?: React.ReactNode;
  showDateRange?: boolean;
}

const WidgetHeader: React.FC<WidgetHeaderProps> = ({
  fallbackTitle,
  trailing,
  showDateRange = true,
}) => {
  const widgetConfig = useWidgetConfig();
  const widget = widgetConfig?.widget ?? null;

  return (
    <div className="flex flex-col gap-0.5">
      <div className="flex items-start gap-1.5">
        <span className="text-primary font-bold text-lg min-w-0 flex-1">
          {widget?.label ?? fallbackTitle}
        </span>
        {widget?.evidence && (
          <EvidenceInfoIcon
            evidence={widget.evidence}
            data-testid={`widget-evidence-icon-${widget.code}`}
          />
        )}
      </div>
      {(trailing || (showDateRange && widgetConfig?.dateRangeLabel)) && (
        <div className="flex items-center gap-1.5">
          {showDateRange && widgetConfig?.dateRangeLabel && (
            <span className="text-xs text-neutral-500">
              {widgetConfig.dateRangeLabel}
            </span>
          )}
          {trailing}
        </div>
      )}
      {widget?.description && (
        <p
          className="text-xs text-secondary leading-snug"
          data-testid="widget-header-description"
        >
          {widget.description}
        </p>
      )}
    </div>
  );
};

export default WidgetHeader;
